import { FunctionComponent } from 'react'
import FreeRatioImage from '@components/FreeRatioImage'
import { ImageConstraints } from '@components/FreeRatioImage/types'
import { TeaserStandardVerticalSponsoredCommercialProps } from '@widgets/TeaserStandardVertical'

type SponsoredLogoProps = Exclude<
  TeaserStandardVerticalSponsoredCommercialProps['commercial']['logo'],
  undefined
>

const CONSTRAINTS = {
  desktop: { width: 120, height: 100 },
  tablet: { width: 90, height: 75 },
  mobile: { width: 90, height: 75 },
  mobileSmall: { width: 90, height: 75 },
} as const satisfies ImageConstraints

const SponsoredLogo: FunctionComponent<SponsoredLogoProps> = ({
  src,
  alt,
  height,
  width,
  crops,
}) => {
  return (
    <FreeRatioImage
      src={src}
      alt={alt}
      crops={crops}
      originalDimensions={{ width, height }}
      constraints={CONSTRAINTS}
    />
  )
}

export default SponsoredLogo
